import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  relativeForm: {
    position: 'relative'
  },
  buttonsWrapper: {
    '& .MuiButton-root + .MuiButton-root': {
      marginTop: '20px'
    }
  },
  inlineSelect: {
    minWidth: '205px',
    marginLeft: '10px',
    marginRight: '10px'
  },
  flexContainer: {
    display: 'flex'
  },
  additionalInfo: {
    color: palette.shades[700],
    marginBottom: '48px',
    marginTop: '18px'
  },
  loaderWrapper: {
    marginTop: '180px',
    textAlign: 'center'
  },
  quote: {
    position: 'relative',
    marginTop: '10px',
    padding: '12px 16px',
    backgroundColor: '#FFFFFF26',
    borderRadius: '8px',
    '&:after': {
      content: "''",
      position: 'absolute',
      width: '0',
      height: '0',
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      borderTop: '8px solid #FFFFFF26',
      bottom: '-8px',
      left: '16px'
    }
  }
}));
export default useStyles;